import React from "react";
import { StyleSheet } from "react-native";
import i18n from "@microdoing/shared/i18n";
import { MainText, PressableOpacity } from "app/components/common";
import theme from "app/Theme/Theme";

const BOX_HEIGHT = 60;

const styles = StyleSheet.create({
  main: {
    width: "100%",
    borderWidth: 1,
    height: BOX_HEIGHT,
    borderRadius: 6,
    borderColor: "#EAEAEA",
    marginTop: 10,
    marginBottom: 15,
    paddingHorizontal: 25,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  boxSelected: {
    borderWidth: 2,
    borderColor: theme.colors["brand.500"],
  },
});

interface Props {
  isSelected?: boolean;
  goalNumber: number;
  onPress: () => void;
}

const GoalBox = ({
  isSelected = false,
  goalNumber,
  onPress = () => null,
}: Props) => {
  return (
    <PressableOpacity
      onPress={onPress}
      style={[styles.main, isSelected ? styles.boxSelected : {}]}
    >
      <MainText
        color={isSelected ? "brand.500" : "neutral.900"}
        variant={isSelected ? "l4-semibold" : "l4-medium"}
      >
        {i18n.t(`weekly-goal-option-${goalNumber}`)}
      </MainText>
      <MainText
        variant={isSelected ? "l4-semibold" : "l4-medium"}
        color={isSelected ? "brand.500" : "neutral.700"}
      >
        {i18n.t(
          goalNumber === 1
            ? "weekly-goal-number-singular"
            : "weekly-goal-number",
          { goalNumber },
        )}
      </MainText>
    </PressableOpacity>
  );
};

export default GoalBox;
